<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">PHASE:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'imPhase'"
                    :name="'imPhase'"
                    :select2-options="imPhaseOptions"
                    v-model="imPhaseModel"
                    data-msg-required="กรุณาเลือก Phase"
                    required
                    ref="imPhaseSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">Lot:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'imLot'"
                    :name="'imLot'"
                    :select2-options="imLotOptions"
                    v-model="imLotModel"
                    required
                    data-msg-required="กรุณาเลือก Lot"
                    ref="imLotSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">จำนวนงวด:</label>
                  <input
                    id="imInstallmentModel"
                    name="imInstallmentModel"
                    v-model="imInstallmentModel"
                    type="number"
                    min="0"
                    class="form-control"
                    data-msg-required="กรุณากรอก จำนวนงวด"
                    placeholder="จำนวนงวด"
                  />
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">PO:</label>
                  <input
                    id="imPOModel"
                    name="imPOModel"
                    v-model="imPOModel"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    data-msg-required="กรุณากรอก PO"
                    placeholder="PO"
                  />
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">วันที่เริ่มสัญญา:</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      id="imStartDateModel"
                      name="imStartDateModel"
                      data-msg-required="กรุณาเลือก วันที่เริ่มสัญญา"
                      required
                      placeholder="วันที่เริ่มสัญญา"
                      ref="imStartDateModel"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                    <span class="form-text"></span>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">ค่าเช่าต่องวด:</label>
                  <input
                    id="imPriceModel"
                    name="imPriceModel"
                    v-model="imPriceModel"
                    type="number"
                    min="0"
                    class="form-control"
                    data-msg-required="กรุณากรอก ค่าเช่าต่องวด"
                    placeholder="ค่าเช่าต่องวด"
                  />
                </div>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="importFile"
                    lang="es"
                  />
                  <label class="custom-file-label" for="importFile">{{
                    Flie
                  }}</label>
                  <!-- <button id="import" class="btn btn-primary" @click="ImportFile">อัพโหลด</button> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table
                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                  id="PreviewTable"
                  style="width: 100%;"
                ></table>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="reset" class="btn btn-danger" @click="resetFile">
            <i class="la la-close"></i> ล้างค่า
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import datepicker from "../../../Shared/Datepicker";

export default {
  components: {
    datepicker,
    select2,
  },
  data: function() {
    var self = this;
    return {
      Flie: "เลือกไฟล์ เครื่องเช่า",
      seen: false,
      dataList: [],
      valid: true,

      imInstallmentModel: 60,
      imPOModel: null,
      imStartDateModel: null,
      imPriceModel: null,
      imPhaseModel: null,
      imPhaseOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      imLotModel: null,
      imLotOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Lot",
          data: function(params) {
            var query = {
              search: params.term,
              phase: self.imPhaseModel,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    resetFile: function() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importFile").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์ เครื่องเช่า";
      this.dataList = [];
    },
    formSubmit: function(e) {
      let self = this;
      let router = this.$router;
      e.preventDefault();
      //   var valid = false;
      //   console.log(self.valid);
      if (
        !$(self.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }
      if (!self.valid) {
        return false;
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/MachineTransaction/Import", this.dataList)
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      // }
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.imStartDateModel).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment().subtract(1, "month"), //last month
      maxDate: moment(), //current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.imStartDateModel = moment();
    $(self.$refs.imStartDateModel)
      .datepicker("update", self.imStartDateModel.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.imStartDateModel = moment(e.date);
      });

    $("#importFile").change(function(e) {
      self.seen = true;
      self.Flie = e.target.files[0].name;

      if (
        !$(self.$refs.form)
          .validate()
          .form()
      ) {
        $("#importFile").val("");
        self.seen = false;
        self.Flie = "เลือกไฟล์ เครื่องเช่า";
        return false;
      }

      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังแสดงข้อมูล กรุณารอสักครู่...",
      });

      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("Installment", self.imInstallmentModel);
      formData.append("PO", self.imPOModel);
      formData.append("StartDate", self.imStartDateModel.format("DD/MM/YYYY"));
      formData.append("Price", self.imPriceModel);
      formData.append("Phase", self.imPhaseModel);
      formData.append("Lot", self.imLotModel);
      axios
        .post("/Api/MachineTransaction/Preview", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          //console.log(response);
          if (response.status == 400) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          } else if (response.status == 200) {
            self.dataList = response.data;
            var $table = $("#PreviewTable");
            var head =
              "<thead>" +
              '<tr role="row">' +
              '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" >ลำดับ</th>' +
              '<th class="text-center" aria-label="ระบุ PHASE: activate to sort column ascending" >ระบุ PHASE</th>' +
              '<th class="text-center" aria-label="ระบุ Lot: activate to sort column ascending" style="width:8% ;" >ระบุ Lot</th>' +
              '<th class="text-center" aria-label="ระบุจำนวนงวด: activate to sort column ascending">ระบุจำนวนงวด</th>' +
              '<th class="text-center" aria-label="เลขที่ PO: activate to sort column ascending" >เลขที่ PO</th>' +
              '<th class="text-center" aria-label="ราคาของเครื่องประเภท: activate to sort column ascending" style="width:8% ;" >ราคาของเครื่องประเภท</th>' +
              '<th class="text-center" aria-label="ว/ด/ป ติดตั้ง: activate to sort column ascending">ว/ด/ป ติดตั้ง</th>' +
              '<th class="text-center" aria-label="ว/ด/ป เริ่มสัญญา: activate to sort column ascending" >ว/ด/ป เริ่มสัญญา</th>' +
              '<th class="text-center" aria-label="BARCODE: activate to sort column ascending" style="width:8% ;" >BARCODE</th>' +
              '<th class="text-center" aria-label="สถานะ: activate to sort column ascending">สถานะ</th>' +
              '<th class="text-center" aria-label="Id: activate to sort column ascending">Id</th>' +
              '<th class="text-center" aria-label="RefCode: activate to sort column ascending">RefCode</th>' +
              // '<th class="text-center" aria-label="ID: activate to sort column ascending">ID</th>' +
              "</tr>" +
              "</thead>";
            $table.append(head);
            var data = response.data;
            var table_body = $("<tbody></tbody>");
            for (var i = 0; i < data.length; i++) {
              var borders_oldbarcode = null;
              var borders_remark = null;
              var borders_installDate = null;
              if (!data[i].validOldBarcode) {
                borders_oldbarcode = 'style="color:#ff0000;"';
              }
              if (!data[i].validInstallDate) {
                borders_installDate = 'style="color:#ff0000;"';
              }
              //console.log(data[i].validates);
              self.valid = self.valid || data[i].validates;
              if (!data[i].validates) {
                borders_remark = 'style="color:#ff0000;"';
              }
              $(
                `<tr role="row" class="odd">
                  <td class="text-center">${i + 1}</td>
                  <td class="text-center">${data[i].phase}</td>
                  <td class="text-center">${data[i].lot}</td>
                  <td class="text-center">${data[i].installment}</td>
                  <td class="text-center">${data[i].po}</td>
                  <td class="text-center">${data[i].price}</td>
                  <td class="text-center" ${borders_installDate}>
                    ${data[i].validInstallDate == false ? data[i].pInstallDate : data[i].installDate}
                  </td>
                  <td class="text-center">${data[i].startDate}</td>
                  <td class="text-center" ${borders_oldbarcode}>
                    ${data[i].pOldBarcode != null ? data[i].pOldBarcode : ""}
                  </td>
                  <td class="text-center" ${borders_remark}>${data[i].remark}</td>
                  <td class="text-center">${data[i].id}</td>
                  <td class="text-center">${data[i].refCode}</td>
                </tr>`
              ).appendTo(table_body);
              table_body.appendTo($table);
            }
          }
          KTApp.unblockPage();
        })
        .catch(function(error) {
          //console.log(error.response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          KTApp.unblockPage();
        });
    });

    // set validation rules
    $(self.$refs.form).validate({
      rules: {
        imInstallmentModel: "required",
        imPOModel: "required",
        imStartDateModel: "required",
        imPriceModel: "required",
        imLotModel: "required",
        imPhaseModel: "required",
      },
      messages: {
        imInstallmentModel: "กรุณากรอกจำนวนงวด",
        imPOModel: "กรุณากรอกPO",
        imStartDateModel: "กรุณาเลือกวันที่เริ่มสัญญา",
        imPriceModel: "กรุณากรอกค่าเช่าต่องวด",
        imLotModel: "กกรุณาเลือกLot",
        imPhaseModel: "กรุณาเลือกPhase",
      },
    });
    $(self.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  cursor: pointer;
}

td.border_single {
  border: 1px solid #ff0000;
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/MachineTransaction/ImportMachineTransaction.vue